module.exports = __webpack_public_path__ + "static/media/icon22.070a7716.png";